module.exports = __webpack_public_path__ + "img/girls-ms.5ac3c80d.jpg";